export const MsgSuccessOptions = {
  position: 'bottom-right',
  style: {
    backgroundColor: '#d1e7dd',
    border: '2px solid #93c7af',
    color: '#0f5132',
    fontFamily: 'Menlo, monospace',
    fontSize: '20px',
    textAlign: 'center',
  },
  closeStyle: {
    color: 'lightcoral',
    fontSize: '16px',
  },
}
